import { Car, Users, Briefcase } from "lucide-react";

export const Fleet = ({ config }) => (
  <section id="fleet" className="scroll-mt-20 border-b border-white/10 bg-[#0c1220] py-20" data-testid="fleet-section">
    <div className="mx-auto max-w-6xl px-6">
      <div className="mb-10 flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="font-mono-lbl text-xs uppercase tracking-widest text-[#38bdf8]">Executive Fleet</span>
          <h2 className="mt-2 font-disp text-3xl uppercase text-white md:text-4xl">The Right Car for Every Party</h2>
        </div>
        <p className="max-w-sm text-sm text-slate-400">Professional licensed drivers, executive vehicles, and space for the whole family's luggage.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {(config?.vehicles || []).map((v) => (
          <div key={v.id} data-testid={`fleet-card-${v.id}`} className="rounded-2xl border border-white/10 bg-white/5 p-5 transition-colors hover:border-[#38bdf8]/50">
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-[#38bdf8]/10 text-[#38bdf8]">
              <Car className="h-5 w-5" />
            </div>
            <h3 className="font-disp text-lg uppercase text-white">{v.name}</h3>
            <div className="mt-2 flex items-center gap-4 font-mono-lbl text-xs text-slate-400">
              <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" /> {v.seats} seats</span>
              <span className="flex items-center gap-1.5"><Briefcase className="h-3.5 w-3.5" /> {v.bags} cases</span>
            </div>
          </div>
        ))}
        {!config && [1, 2, 3, 4].map((i) => (
          <div key={i} className="h-32 animate-pulse rounded-2xl border border-white/10 bg-white/5"></div>
        ))}
      </div>
    </div>
  </section>
);
